import { createContext, useContext } from 'react';
import { initialState } from './Sockets.constants';
import { tUseSockets } from './Sockets.types';

export const SocketsContext = createContext<tUseSockets>(initialState);
export const useSocketsContext = (): tUseSockets => useContext(SocketsContext);
